__turbopack_context__.v({
  "active": "LoH98G_active",
  "chevron": "LoH98G_chevron",
  "container": "LoH98G_container",
  "link": "LoH98G_link",
  "links": "LoH98G_links",
  "sublink": "LoH98G_sublink",
  "title": "LoH98G_title",
  "toggle": "LoH98G_toggle",
});
